import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';
import { combineReducers } from 'redux';
import ActionTypes from './actionTypes';
/**
 * Updates the data of the case workers entity within the Redux store.
 */

var reducers = /*#__PURE__*/function () {
  function reducers() {
    _classCallCheck(this, reducers);
  }

  _createClass(reducers, null, [{
    key: "caseworkersDataReducer",

    /**
     * Updates the case workers data within the Redux store.
     * @param {Object} state
     * @param {Object} action
     */
    value: function caseworkersDataReducer() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var action = arguments.length > 1 ? arguments[1] : undefined;
      return ReduxUtils.generateReducer(state, action, ActionTypes.caseworkersActionTypes);
    }
    /**
     * Updates the flag in the Redux store which represents the status of fetching the
     * organisation data from it.
     * @param {Object} state
     * @param {Object} action
     */

  }, {
    key: "isFetchingCaseworkersDataReducer",
    value: function isFetchingCaseworkersDataReducer() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var action = arguments.length > 1 ? arguments[1] : undefined;
      return ReduxUtils.generateFetchingReducer(state, action, ActionTypes.caseworkersActionTypes);
    }
    /**
     * Updated the error object in the Redux store if there was a problem fetching the
     * organisation data from it.
     * @param {Object} state
     * @param {Object} action
     */

  }, {
    key: "caseworkersDataErrorReducer",
    value: function caseworkersDataErrorReducer() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var action = arguments.length > 1 ? arguments[1] : undefined;
      return ReduxUtils.generateErrorReducer(state, action, ActionTypes.caseworkersActionTypes);
    }
    /**
     * The default reducer for the case workers.
     */

  }]);

  return reducers;
}();

_defineProperty(reducers, "rootReducer", combineReducers({
  data: reducers.caseworkersDataReducer,
  isProcessing: reducers.isFetchingCaseworkersDataReducer,
  error: reducers.caseworkersDataErrorReducer
}));

export { reducers as default };